import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/SupplierAgentCommission`;


const ApiSupplierAgents = {
  getAllSupplierAgents: (params) => {
    const url = `${baseServiceUrl}/getAllSupplierAgentCommissions`
    return ServiceApi.get(url, { params });
  },
  getAllAgentsBySupplierId: (params) => {
    const url = `${baseServiceUrl}/getAllAgentsBySupplierId`
    return ServiceApi.get(url, { params });
  },
  getAllSuppliersByAgentId: (params) => {
    const url = `${baseServiceUrl}/getAllSuppliersByAgentId`
    return ServiceApi.get(url, { params });
  },
  createAndUpdateSupplierAgentByAgentId: (params) => {
    const url = `${baseServiceUrl}/createEditSupplierAgentCommissionByAgentId`;
    return ServiceApi.post(url, params);
  },
  createAndUpdateSupplierAgentBySupplierId: (params) => {
    const url = `${baseServiceUrl}/createEditSupplierAgentCommissionBySupplierId`;
    return ServiceApi.post(url, params);
  },
};

export default ApiSupplierAgents;